import { OSStep } from "@/molecules/OSStep"
import {
  DeployTab,
  TitleStepDeployTab,
  type CommonDeployTabProps
} from "@/pages/DeploymentsPage/components/molecules/DeployTab"
import { DownloadStep } from "@/pages/DeploymentsPage/components/organisms/DownloadStep"
import { VmDeployCommand } from "@/pages/DeploymentsPage/components/organisms/VmDeployCommand"
import {
  PACKAGE_SPEC_TYPE,
  SIDE_SCAN_CF_FILENAME,
  SIDE_SCAN_ONBOARDING_TEMPLATE_URL
} from "@/pages/DeploymentsPage/const"
import { getVMFiles } from "@/pages/DeploymentsPage/helpers/file"
import { MessageVmTab } from "../VmTab"

export const EC2Tab = (props: CommonDeployTabProps) => {
  const { noError, version } = props
  const {
    items,
    isWindows: _isWindows,
    ...rest
  } = OSStep({
    getSteps: ({ isWindows, OSPlatform, t }) => {
      const tKey = isWindows ? "windows" : "vm"

      return [
        {
          title: (
            <DownloadStep
              noError={noError}
              files={[
                {
                  name: SIDE_SCAN_CF_FILENAME,
                  contentEndpoint: SIDE_SCAN_ONBOARDING_TEMPLATE_URL
                }
              ]}
              titlePrefix={t("general.deploy")}
              title={t("deployments.ec2.cloudFormationStep")}
            />
          ),
          status: "process"
        },
        {
          title: (
            <DownloadStep
              noError={noError}
              files={getVMFiles({
                version,
                OSPlatform,
                packageSpecType: PACKAGE_SPEC_TYPE.EC2
              })}
              titlePrefix={t("general.download")}
              title={t(`deployments.${tKey}.deploymentStep`)}
            />
          ),
          status: "process"
        },
        {
          title: (
            <TitleStepDeployTab prefix={t("general.deploy")}>
              {`- ${t(`deployments.${tKey}.commandStep`)}`}
            </TitleStepDeployTab>
          ),
          description: (
            <VmDeployCommand
              deploymentKeyDelimiter="EC2"
              // Side-scan needs koltan in REQUIREMENTS_ONLY mode (Windows gets it as /MODE=)
              installSuffix="MODE=REQUIREMENTS_ONLY"
              isWindows={isWindows}
              {...props}
            />
          ),
          status: "process"
        }
      ]
    },
    getMessage: MessageVmTab
  })

  return <DeployTab steps={items} {...rest} />
}
